import script from "./Toastr.vue?vue&type=script&setup=true&lang=js"
export * from "./Toastr.vue?vue&type=script&setup=true&lang=js"

import "./Toastr.vue?vue&type=style&index=0&id=4b2123cc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b2123cc"]])

export default __exports__